module.exports = __webpack_public_path__ + "img/FJ.860b112b.svg";